<template>
  <p
    class="helper-text"
    data-sb-regression="sb-helper-text"
  >
    <!-- @slot slot to show the field helper text -->
    <slot />
    <span
      v-if="hasCounter"
      class="counter-text"
    >
      {{ textValueLength }} / {{ maxLengthValue || counterValue }}
    </span>
  </p>
</template>

<script>
/**
 * Helper text to be used with SbFields. Contains counter and maxlength text that can be displayed when this component is used with a TextInput.
 */
export default {
  name: 'SbFieldHelperText',
  inject: ['sbField'],
  props: {
    /**
     * Used as a visual inside the SbFieldHelperText.
     */
    counter: {
      type: Number,
      default: null,
    },
  },
  computed: {
    hasCounter() {
      return this.maxLengthValue !== null || this.counterValue !== null;
    },
    textValueLength() {
      return (this.sbField.value && this.sbField.value.length) || 0;
    },
    maxLengthValue() {
      return this.sbField.maxlength;
    },
    counterValue() {
      return this.sbField.counter;
    },
  },
  mounted() {
    this.sbField.counter = this.sbField.counter || this.counter;
  },
};
</script>

<style lang="scss" scoped>
</style>
